import FeedbackSuccess from '../../../components/atoms/feedbacks/feedback-success'
import FeedbackError from '../../../components/atoms/feedbacks/feedback-error'
import WishListContents from '../../../components/organism/mypages/profiles/WishListContents'
import SmallLoading from '../../../components/atoms/loadings/SmallLoading'
import AccountIconWh104 from '../../../components/atoms/account_icons/AccountIconWh104'

import axios from 'axios'

export default {
  components: {
    FeedbackSuccess,
    FeedbackError,
    WishListContents,
    SmallLoading,
    AccountIconWh104
  },
  data() {
    return {
      screenName: '',
      host: '',
      showableSuccessFeedback: false,
      showableErrorFeedback: false,
      successMessage: '',
      errorMessage: '',
      wishListTickets: [],
      isWishListTicketLoading: false,
      isSameUserAsGiftCardRecipient: false
    }
  },
  computed: {
    shareUrl() {
      return `https://${this.host}/u/${this.screenName}`
    }
  },
  mounted() {
    // https://giftee.com/u/screen_name の screen_name を取得
    this.screenName = location.pathname.split('/')[2]
    // https://giftee.com/u/screen_name の giftee.com を取得
    this.host = location.host

    const profileFeedbackMessage = document.querySelector('#flash_message')
      .value

    if (profileFeedbackMessage) {
      this.showFeedback(profileFeedbackMessage)
    }

    this.getTickets()
    this.getWishListUserGiftCardEditingStatus()
  },
  methods: {
    enterSuccessFeedback() {
      setTimeout(() => {
        this.showableSuccessFeedback = false
      }, 3000)
    },
    enterErrorFeedback() {
      setTimeout(() => {
        this.showableErrorFeedback = false
      }, 3000)
    },
    onClickTwitterButton() {
      window.open(
        `https://twitter.com/intent/tweet?text=gifteeで${this.screenName}のほしいものをチェック！&hashtags=giftee&url=${this.shareUrl}&original_referer=${this.shareUrl}`,
        '_blank'
      )
    },
    onClickFacebookButton() {
      window.open(
        `https://www.facebook.com/sharer.php?u=${this.shareUrl}`,
        '_blank'
      )
    },
    copyShareUrl() {
      // 参考: https://stackoverflow.com/questions/58733960/copy-url-to-clipboard-via-button-click-in-a-vuejs-component
      const el = document.createElement('textarea')
      el.value = this.shareUrl
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.showFeedback('URLをコピーしました')
    },
    showFeedback(message) {
      this.showableSuccessFeedback = true
      this.successMessage = message
    },
    async getTickets() {
      this.isWishListTicketLoading = true
      try {
        const res = await axios.get(
          `/api/v1/wish_lists?screen_name=${this.screenName}`
        )
        this.wishListTickets = res.data.data.map(wishListTicket => {
          // TODO: dummyimage を正式が画像に置換する
          const itemSkuImageUrl = wishListTicket.attributes.item_sku_image_url
            ? wishListTicket.attributes.item_sku_image_url
            : 'https://dummyimage.com/90x90/ccc/999.png&text=Not+Found'
          return {
            id: wishListTicket.attributes.id,
            imageUrl: itemSkuImageUrl,
            itemSkuId: wishListTicket.attributes.item_sku_id,
            itemSkuName: wishListTicket.attributes.item_sku_name,
            itemId: wishListTicket.attributes.item_id,
            itemName: wishListTicket.attributes.item_name,
            brandName: wishListTicket.attributes.item_sku_brand_name,
            isSoldOut: wishListTicket.attributes.is_sold_out
          }
        })
        this.isWishListTicketLoading = false
      } catch (error) {
        this.isWishListTicketLoading = false
        this.showableErrorFeedback = true
        // error.response.data.message が null の場合に備えて初期値をセットする
        this.errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
      }
    },
    async getWishListUserGiftCardEditingStatus() {
      try {
        const res = await axios.get(
          `/api/v1/pickup/gift_card_sessions/edit_status?screen_name=${this.screenName}`
        )
        this.isSameUserAsGiftCardRecipient = res.data.edit_status
      } catch (error) {
        this.showableErrorFeedback = true
        this.errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
      }
    },
    showError(error) {
      this.showableErrorFeedback = true
      this.errorMessage =
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
    }
  }
}
